import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { CoursesService } from 'src/app/services/courses.service';
import { ModulesService } from 'src/app/services/modules.service';
import { LessonsService } from 'src/app/services/lessons.service';
import { ContentService } from 'src/app/services/content.service';
import { Subject, takeUntil } from 'rxjs';
import { LocalstorageService } from 'src/app/services/localstorage.service';

@Component({
  selector: 'app-mobile-menu',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss']
})
export class MobileMenuComponent {
  @Input() isOpen = false;
  @Output() closeMenu = new EventEmitter<void>();
  hide: boolean = true;
  evaluationPassed: boolean[] = [];
  user:any;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private authService: AuthService, private router: Router, public course:CoursesService, public modules: ModulesService, public lesson:LessonsService,
    public contentService: ContentService, private localStorage: LocalstorageService) { }

  // ngOnInit(): void {
  //   this.user = this.localStorage.getCurrentUserAsJson();
  //   this.contentService.evaluations.forEach((elements:any, i:number) => {
  //     console.log(elements)
  //     elements.forEach((evaluation:any) => {
  //       this.statusEvaluation(this.user.uid, evaluation.attributes.drupal_internal__nid, i);
  //     })
  //   });
  // }

  logout(){
    this.authService.logoutWithCookie(localStorage.getItem('logout_token_edutegia'),
    localStorage.getItem('global_token_edutegia'))
    .subscribe((resp:any) => {
      // console.log("logout")
      if(resp===null){
        this.router.navigate(['/login']);
      }
    });
  }

  shouldHideButton(): boolean {
    const currentUrl = this.router.url;
    const hideContent = currentUrl.startsWith('/cursos/');
    hideContent ? this.hide= true : false;
    return hideContent
  }

  disableSidenav(url:string):boolean {
    return url.startsWith('/dashboard');
  }

  allLessonsCompleted(index: number): boolean {
    return this.lesson.lessons[index]?.every((lesson:any) => lesson.checked);
  }

  statusEvaluation(userId:number, evaluationId:number, moduleIndex: number) {
    this.contentService.getGradesEvaluation(userId, evaluationId).pipe(takeUntil(this.destroy$)).subscribe({
      next: intents => {
        let passed = false;
        intents.forEach((intent:any) => {
          if (intent.field_rating[0].value >= 80) {
            passed = true;
          }
        });
        this.evaluationPassed[moduleIndex] = passed;
      },
      error: error => console.error('Error trayendo las notas de la evaluación', error)
    });
  }

  isModuleClickable(index: number): boolean {
    if(index === 0) {
      return true;
    }
    return this.evaluationPassed[index - 1];
  }

  onClick(){
    this.closeMenu.emit();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
